import type { FC } from 'react'

import { useSelector } from 'react-redux'

import { getSettings } from '@/ducks/devicePolicyReducer'

import { Translation } from '../i18n/Translation'

import InventoryDevice from './InventoryDevice'
import type { Settings, Inventory as InventoryType } from './types'

import './style/inventory.scss'

const Inventory: FC<{
  display: boolean
  devices: string[]
  models: Record<string, InventoryType>
  onDeviceSelect: (device: string) => void
}> = ({ models, devices, display, onDeviceSelect }) => {
  const settings: Settings = useSelector(getSettings)

  // todo: check when this could be null????
  if (settings === null)
    return (
      <div id="no-access">
        <Translation id="Din arbeidsgiver har ikke aktivert kjøp av telefon." />
      </div>
    )

  if (!display || !devices) return <div id="inventory">{null}</div>

  return (
    <div id="inventory">
      {devices.map(item => (
        <InventoryDevice key={item} item={item} models={models} onDeviceSelect={onDeviceSelect} />
      ))}
    </div>
  )
}

export default Inventory
